import React, { useEffect, useState } from 'react'
import SplashScreenContext from './SplashScreenContext'

export default function SplashScreenContextProvider(props: any) {
  const { children } = props
  const [count, setCount] = useState(0)
  const visible = count > 0

  useEffect(() => {
    const splashScreen = document.getElementById('splash-screen')

    if (!splashScreen) {
      return
    }

    // Show SplashScreen
    if (visible) {
      splashScreen.classList.remove('hidden')

      return () => {
        splashScreen.classList.add('hidden')
      }
    }

    // Hide SplashScreen
    const timeout = setTimeout(() => {
      splashScreen.classList.add('hidden')
    }, 500)

    return () => {
      clearTimeout(timeout)
    }
  }, [visible])

  return <SplashScreenContext.Provider value={setCount}>{children}</SplashScreenContext.Provider>
}
